export default "__VITE_ASSET__CfA6GuKy__"